import { useContext, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { UserContext } from '../../../context/authContext';
import { calculateComplianceCoins } from './helpers';
import { Button } from '@cloudscape-design/components';
import { ScrollDownArrow } from '../shared/scrollDownArrow';
import { useLocation } from 'react-router-dom';
import { KoruLoading } from '../shared/KoruLoading';
import { useAlert } from '../../../context/alertContext';

interface SeparateRecords {
  chatRecords: any[];
  rfpRecords: any[];
  chatTotal: number;
  rfpTotal: number;
}
export const TokenViewer = () => {
  const { auth, token } = useContext(UserContext);
  const { setSubsAlert } = useAlert();
  const [tokenRecords, setTokenRecords] = useState<SeparateRecords>();
  const [availableCoins, setAvailableCoins] = useState<number>(0);
  const [currentHoldCoins, setCurrentHoldCoins] = useState<number>(0);
  const [currentPagesProcessed, setCurrentPagesProcessed] = useState<number>(0);

  const [currentHoldPages, setCurrentHoldPages] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  // const getAllCustomerTokens = async () => {
  //   setLoading(true);
  //   try {
  //     const result = await axios.post(
  //       `${process.env.REACT_APP_KORU_API}/document?type=getTokensByCustomer`,
  //       {},
  //       auth
  //     );
  //     if (result.data?.result) {
  //       const separatedRecords = result.data.result.reduce(
  //         (acc: any, curr: any) => {
  //           console.log('current');
  //           const isUUID =
  //             /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
  //               curr._id
  //             );
  //           if (!isUUID) {
  //             acc.rfpRecords.push({
  //               ...curr,
  //               documentFileName: curr.items[0]?.Document[0]?.documentFileName,
  //               date: new Date(curr.items[0].createdAt)
  //             });
  //             acc.rfpTotal =
  //               acc.rfpTotal +
  //               calculateComplianceCoins(
  //                 curr.tokensInTotal,
  //                 curr.tokensOutTotal
  //               );
  //           } else {
  //             acc.chatRecords.push({
  //               ...curr,
  //               searchText: curr.items[0].searchText,
  //               date: new Date(curr.items[0].createdAt)
  //             });
  //             acc.chatTotal =
  //               acc.chatTotal +
  //               calculateComplianceCoins(
  //                 curr.tokensInTotal,
  //                 curr.tokensOutTotal
  //               );
  //           }
  //           return acc;
  //         },
  //         {
  //           chatRecords: [],
  //           rfpRecords: [],
  //           chatTotal: 0,
  //           rfpTotal: 0
  //         } as SeparateRecords
  //       );
  //       console.log('separated records', separatedRecords);
  //       setTokenRecords(separatedRecords);
  //     }
  //     setLoading(false);
  //   } catch (e: any) {
  //     console.error('Error fetching token records:', e.message);
  //   }
  // };

  useEffect(() => {
    console.log('first load');
    if (!token) return;
    // getAllCustomerTokens();
    getAvailableCoins();
    getCurrentHoldCoins();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log('token change load');
    if (!token) return;
    // getAllCustomerTokens();
    getAvailableCoins();
    getCurrentHoldCoins();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    console.log('location change load');
    if (!token) return;
    // getAllCustomerTokens();
    getAvailableCoins();
    getCurrentHoldCoins();
    getCurrentUsedPages();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key]); // triggers on every navigation, even to same route

  const getAvailableCoins = async () => {
    try {
      const resultAvailCoins = await axios.post(
        `${process.env.REACT_APP_KORU_API}/document?type=availableCoinsByCustomer`,
        {},
        auth
      );
      console.log('result Available coins', resultAvailCoins);
      setAvailableCoins(resultAvailCoins.data.result);
    } catch (e) {
      console.log('error from available coins', e);
    }
  };
  const getCurrentHoldCoins = async () => {
    try {
      const resultHoldCoins = await axios.post(
        `${process.env.REACT_APP_KORU_API}/document?type=currentHoldCoins`,
        {},
        auth
      );
      console.log('result Available coins', resultHoldCoins);
      setCurrentHoldCoins(resultHoldCoins.data.result);
    } catch (e: any) {
      console.log('error getting current hold coins', e.message);
    }
  };
  const getCurrentUsedPages = async () => {
    try {
      const resultPagesProcessed = await axios.post(
        `${process.env.REACT_APP_KORU_API}/document?type=currentPageCount`,
        {},
        auth
      );
      setCurrentPagesProcessed(resultPagesProcessed.data.result);
      const currentHoldPages = await axios.post(
        `${process.env.REACT_APP_KORU_API}/document?type=currentHoldPages`,
        {},
        auth
      );
      setCurrentHoldPages(currentHoldPages.data.result);
    } catch (e) {
      const error = e as Error;
      console.log('error getting current hold coins', error.message);
    }
  };
  // const buyMoreCoins = async (coinsToBuy: number) => {
  //   try {
  //     const result = await axios.post(
  //       `${process.env.REACT_APP_KORU_API}/document?type=coinsPurchase`,
  //       { number: coinsToBuy },
  //       auth
  //     );
  //     console.log('Result from purchase coins', result);
  //     // getAllCustomerTokens();
  //     getAvailableCoins();
  //   } catch (e: any) {
  //     console.error('Error purchasing coins', e.message);
  //   }
  // };

  return (
    <>
      {!loading ? (
        <div
          className="relative h-screen overflow-y-auto"
          ref={containerRef}
          style={{ scrollbarWidth: 'none' }}
        >
          <div className="p-4">
            <div className="p-4 w-full bg-white border border-gray-300 rounded-md shadow-sm mb-6">
              <div className="flex flex-row justify-between mb-4">
                <h2 className="text-xl font-semibold mb-4 text-gray-800">
                  Monthly Compliance Credit Usage
                </h2>
                <div className="space-x-2">
                  <Button
                    variant="primary"
                    onClick={() => setSubsAlert('', 'coins')}
                  >
                    Buy More Credit
                  </Button>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4 text-lg">
                <div className="bg-blue-50 p-4 rounded-md">
                  <p className="text-blue-700 font-medium">
                    Search-Based Queries
                  </p>
                  <p className="text-blue-900 text-2xl font-bold">
                    {tokenRecords?.chatTotal} Credits
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-md">
                  <p className="text-green-700 font-medium">
                    RFP File Analysis
                  </p>
                  <p className="text-green-900 text-2xl font-bold">
                    {tokenRecords?.rfpTotal} Credits
                  </p>
                </div>
                <div className="bg-yellow-50 p-4 rounded-md">
                  <p className="text-yellow-700 font-medium">
                    Remaining Balance
                  </p>
                  <p className="text-yellow-900 text-2xl font-bold">
                    {availableCoins.toFixed(2)} Credits
                  </p>
                </div>
                <div className="bg-yellow-50 p-4 rounded-md">
                  <p className="text-yellow-700 font-medium">Hold Balance</p>
                  <p className="text-yellow-900 text-2xl font-bold">
                    {currentHoldCoins} Credits
                  </p>
                </div>
                <div className="bg-yellow-50 p-4 rounded-md">
                  <p className="text-yellow-700 font-medium">Pages Processed</p>
                  <p className="text-yellow-900 text-2xl font-bold">
                    {currentPagesProcessed} Pages
                  </p>
                </div>
                <div className="bg-yellow-50 p-4 rounded-md">
                  <p className="text-yellow-700 font-medium">Pages Hold</p>
                  <p className="text-yellow-900 text-2xl font-bold">
                    {currentHoldPages} Pages
                  </p>
                </div>
              </div>
            </div>
            {/* <div className="flex flex-row bg-white border border-gray-300 rounded-md shadow-sm mb-6">
              {tokenRecords?.chatRecords &&
              tokenRecords?.chatRecords.length > 0 ? (
                <div className="flex flex-col w-[50%] p-4">
                  <h3 className="text-2xl font-bold">Chat Request</h3>

                  {tokenRecords?.chatRecords
                    .sort((a, b) => b.date - a.date)
                    .map((rec, index) => (
                      <div
                        key={index}
                        className="gap-4 mb-3 border p-3 rounded bg-gray-100"
                      >
                        <p>
                          <strong>Search:</strong> {rec._id}
                        </p>
                        <p>
                          <strong>Search:</strong> {rec.searchText}
                        </p>
                        <div className="flex flex-row justify-between">
                          <p>
                            <strong>Date:</strong>{' '}
                            {new Date(
                              rec.items[0].createdAt
                            ).toLocaleDateString()}
                          </p>
                          <p>
                            <strong>Compliance Coins</strong>{' '}
                            {calculateComplianceCoins(
                              rec.tokensInTotal,
                              rec.tokensOutTotal
                            )}
                          </p>
                        </div>
                      </div>
                    ))}
                </div>
              ) : null}
              {tokenRecords?.rfpRecords &&
              tokenRecords?.rfpRecords.length > 0 ? (
                <div className="flex flex-col w-[50%] p-4">
                  <h3 className="text-2xl font-bold">RFP Files</h3>

                  {tokenRecords?.rfpRecords
                    .sort((a, b) => b.date - a.date)
                    .map((rec, index) => (
                      <div
                        key={index}
                        className="grid grid-cols-3 gap-4 mb-3 border p-3 rounded bg-gray-100"
                      >
                        <p>
                          <strong>Search:</strong> {rec.documentFileName}
                        </p>

                        <p>
                          <strong>Date:</strong>{' '}
                          {new Date(
                            rec.items[0].createdAt
                          ).toLocaleDateString()}
                        </p>
                        <p>
                          <strong>Compliance Coins</strong>{' '}
                          {calculateComplianceCoins(
                            rec.tokensInTotal,
                            rec.tokensOutTotal
                          )}
                        </p>
                      </div>
                    ))}
                </div>
              ) : null}
            </div> */}
          </div>
          <ScrollDownArrow
            containerRef={containerRef as React.RefObject<HTMLElement>}
            bottomValue="12%"
          />
        </div>
      ) : (
        // <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
        //   <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
        // </div>
        <KoruLoading centerText="Gathering Info" />
      )}
    </>
  );
};
